import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import type { TicketSaleTarget } from 'Services/SalesManagement/Features/TicketSale/types'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { styled } from '@mui/material/styles'
import { t } from 'ttag'

interface TicketSaleTargetDetailsProps {
  ticketSaleTarget: TicketSaleTarget
}

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

export default function TicketSaleTargetDetails({
  ticketSaleTarget
}: Readonly<TicketSaleTargetDetailsProps>) {
  const { getAuthorityNameByCode } = useAuthorityContext()
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{ticketSaleTarget.identifier}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Description`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(ticketSaleTarget.description)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Authority`}</StyledTableCell>
            <TableCell>{getAuthorityNameByCode(ticketSaleTarget.authority)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(ticketSaleTarget.created)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
